// @flow
import * as React from 'react';
import UnauthHomePage from 'app/common/react/components/growth/unauth/UnauthHomePage/UnauthHomePage';
import withRouteData from 'app/common/lib/react/withRouteData';
import { compose } from 'redux';

const UnauthHome = () => <UnauthHomePage options={{}} />;

export default compose(
  // $FlowFixMe: new errors found from flow 0.96 upgrade
  withRouteData({
    name: 'UnauthHomeReactPage',
    routeContextLog: () => ({
      view_type: PCONST.thrift.ViewType.FEED,
      view_parameter: PCONST.thrift.ViewParameterType.FEED_HOME,
    }),
  }),
)(UnauthHome);
